import { Controller } from "@hotwired/stimulus"

// Ephemeral controller injected via Turbo Stream to dispatch custom events.
// Dispatches claim:confirmed on document, then removes itself from the DOM.
export default class extends Controller {
  static values = { personId: Number }

  connect() {
    document.dispatchEvent(
      new CustomEvent("claim-event:confirmed", {
        detail: { personId: this.personIdValue }
      })
    )
    this.element.remove()
  }

  disconnect() {
    // no-op — element already removed
  }
}
